import { BASE_URL_ONLINE_DOCS, DOC_HOST } from '../../base/constants/cgi-base';
/**
 * 【兼容方案】drive 品类的 data/get 方法
 * 用于暂时替代没有数据直出 basicClientVars 场景的数据初始化
 */
export var AUTH_DATA_INFO = "".concat(DOC_HOST, "/dop-api/drive/data/get");
/**
 * 获取文档/文件夹权限信息
 */
export var GET_AUTH_INFO = "".concat(BASE_URL_ONLINE_DOCS, "auth_info/get");
/**
 * 修改文档/文件夹权限信息
 */
export var SET_AUTH_INFO = "".concat(BASE_URL_ONLINE_DOCS, "auth_info/set");
/**
 * 获取文档有效期信息
 */
export var GET_AUTH_EXP = "".concat(BASE_URL_ONLINE_DOCS, "auth_exp/get");
/**
 * 修改文档有效期信息
 */
export var SET_AUTH_EXP = "".concat(BASE_URL_ONLINE_DOCS, "auth_exp/set");
/**
 * 获取权限相关配置
 */
export var GET_AUTH_CONF = "".concat(BASE_URL_ONLINE_DOCS, "auth_getconf");
/**
 * 获取企业账号对外分享权限设置
 */
export var GET_CORP_SHARE_AUTH_INFO = "".concat(DOC_HOST, "/v2/privilege/corpshare/docownerget");
/**
 * 修改企业账号对外分享权限设置
 */
export var SET_CORP_SHARE_AUTH_INFO = "".concat(DOC_HOST, "/v2/privilege/corpshare/docownerset");
/**
 * 设置协作者权限
 */
export var SET_USER = "".concat(DOC_HOST, "/v2/privilege/set_user");
